import React, { useState, useRef, useCallback } from "react";

import {
  Grid,
  Typography,
  FormControl,
  InputLabel,
  OutlinedInput,
  Tooltip,
  Button,
} from "@mui/material";

import { withSnackbar } from "../../../../utils/common/SnackbarHoc";
import HelpIcon from "@mui/icons-material/Help";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "../../../common/SettingsAccordion";

import BrandingColor from "./BrandingColor";
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  Preview,
} from "@mui/icons-material";

interface IProps {
  name: string;
  accordionSettings: any;
  chatbotAppearance: any;
  handleAccordionSettings: (name: string) => void;
  snackbarShowMessage: any;
  handleGeneralSettingsValidation: () => void;
  handleChange: (value: any, key: string) => void;
  setChatbotAppearance: (value: any) => void;
  showAlertForPrevPlayground: any;
  product: any;
}

const ChatbotAppearance = ({
  chatbotAppearance,
  accordionSettings,
  handleAccordionSettings,
  name,
  setChatbotAppearance,
  showAlertForPrevPlayground,
  product,
}: IProps) => {
  const handleFontFamily = (value: string) => {
    if (chatbotAppearance) {
      const temp: any | undefined = { ...chatbotAppearance };
      if (temp) {
        temp["cuvo-chatbot-header-text-font-family"] = value;
        temp["cuvo-chatbot-bot-text-font-family"] = value;
        temp["cuvo-chatbot-user-text-font-family"] = value;
        temp["cuvo-chatbot-input-text-font-family"] = value;
        temp["cuvo-chatbot-bot-action-text-font-family"] = value;
        temp["cuvo-chatbot-primary-button-text-font-family"] = value;
        temp["cuvo-chatbot-secondary-button-text-font-family"] = value;
        setChatbotAppearance(temp);
      }
    }
  };
  const handleAccordianChange = (value: any, type: any, clickType: any) => {
    handleAccordionSettings(type);
  };
  return (
    <Accordion
      expanded={accordionSettings[name]}
      onChange={() => handleAccordionSettings(name)}
    >
      <AccordionSummary aria-controls={"panel1-content"} id={"panel1-header"}>
        <Grid container className="acc-prod-icon">
          <Grid item spacing={2} className="acc-prod-icon">
            Theme and branding{" "}
          </Grid>
          <Grid item spacing={3} className="acc-prod-icon">
            <Tooltip
              title={
                <>
                  <Typography sx={{ fontSize: "12px" }}>
                    Design & Color Settings :
                  </Typography>
                  <Typography sx={{ fontSize: "11px" }}>
                    Customize the colors for the chatbot
                  </Typography>
                </>
              }
              placement="bottom"
            >
              <HelpIcon sx={{ mx: 1, fontSize: "20px" }} />
            </Tooltip>
          </Grid>
          <Grid item sx={{ marginLeft: 2, display: "flex" }}>
            {" "}
            <Tooltip title="Click to view the UI preview" placement="bottom">
              <Preview />
            </Tooltip>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography sx={{ fontWeight: 500, mb: 1 }}>
              Bot Appearance:
              <div className="fontfamiltnotemsg">
                Note: Font family in the Preview will work only for browser
                defined fonts
              </div>
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={3} sx={{ mt: 1 }}>
            <BrandingColor
              chatbotAppearance={chatbotAppearance}
              setChatbotAppearance={setChatbotAppearance}
              field={"Primary Color"}
              bgColor={
                chatbotAppearance &&
                chatbotAppearance["cuvo-chatbot-header-bg-color"]
              }
            />
          </Grid>
          <Grid item xs={12} sm={3} sx={{ mt: 1 }}>
            <BrandingColor
              chatbotAppearance={chatbotAppearance}
              setChatbotAppearance={setChatbotAppearance}
              field={"Action Color"}
              bgColor={
                chatbotAppearance &&
                chatbotAppearance["cuvo-chatbot-bot-action-text-color"]
              }
            />
          </Grid>
          <Grid item xs={12} sm={3} sx={{ mt: 1 }}>
            <BrandingColor
              chatbotAppearance={chatbotAppearance}
              setChatbotAppearance={setChatbotAppearance}
              field={"Bot Msg Box Color"}
              bgColor={
                chatbotAppearance &&
                chatbotAppearance["cuvo-chatbot-bot-bg-color"]
              }
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>Font Family</InputLabel>
              <OutlinedInput
                type="text"
                value={
                  chatbotAppearance &&
                  chatbotAppearance["cuvo-chatbot-header-text-font-family"]
                }
                label="Font Family"
                onChange={(event) => {
                  handleFontFamily(event.target.value);
                }}
              />
            </FormControl>
          </Grid>
        </Grid>

        {/* <MainBranding
          chatbotAppearance={chatbotAppearance}
          handleColorPopovers={handleColorPopovers}
          colorPopovers={colorPopovers}
          handleChange={handleChange}
        />

        <HeaderBranding
          chatbotAppearance={chatbotAppearance}
          handleColorPopovers={handleColorPopovers}
          colorPopovers={colorPopovers}
          handleChange={handleChange}
        />

        <BotMessageInput
          chatbotAppearance={chatbotAppearance}
          handleColorPopovers={handleColorPopovers}
          colorPopovers={colorPopovers}
          handleChange={handleChange}
        />

        <UserMessageInput
          chatbotAppearance={chatbotAppearance}
          handleColorPopovers={handleColorPopovers}
          colorPopovers={colorPopovers}
          handleChange={handleChange}
        />

        <MessageInput
          chatbotAppearance={chatbotAppearance}
          handleColorPopovers={handleColorPopovers}
          colorPopovers={colorPopovers}
          handleChange={handleChange}
        />

        <SendIcon
          chatbotAppearance={chatbotAppearance}
          handleColorPopovers={handleColorPopovers}
          colorPopovers={colorPopovers}
          handleChange={handleChange}
        /> */}
        {/* 
        <Grid
          item
          sx={{ mt: 2, p: 0, mb: 0, lineHeight: 0 }}
          xs={12}
          md={12}
        ></Grid> */}
        <Grid
          item
          sx={{ mt: 2, p: 0, mb: 0, lineHeight: 0 }}
          xs={12}
          md={12}
          className="acc-prod-footer"
        >
          <Tooltip title="Go to Text Settings" placement="bottom">
            <Button
              size="small"
              className="backbtn"
              onClick={(e: any) => {
                handleAccordianChange(true, "generalSettings", "back");
              }}
            >
              {" "}
              &nbsp;
              <KeyboardArrowLeft />
              <span className="acc-prod-prev-span">Previous :</span>&nbsp;{" "}
              <span>Go to Text Settings</span>
            </Button>
          </Tooltip>
          {!showAlertForPrevPlayground &&
            product?.id &&
            product?.version &&
            !product.cloneNewVersion && (
              <Tooltip title="Go to Integration Steps" placement="bottom">
                <Button
                  size="small"
                  className="nextbtn"
                  onClick={(e: any) => {
                    handleAccordianChange(
                      true,
                      "apiIntegrationSettings",
                      "next"
                    );
                  }}
                >
                  &nbsp;<span className="acc-prod-next-span">Next :</span>&nbsp;{" "}
                  <span>Go to Integration Steps</span>
                  <KeyboardArrowRight />
                </Button>
              </Tooltip>
            )}{" "}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default withSnackbar(ChatbotAppearance);
